export default {"src":"/_next/static/media/3implants.5f6eb5ae.svg","height":45,"width":31,"blurWidth":0,"blurHeight":0};